import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ISchool, ISchools } from '../interfaces/school';
import {
  IGradeSystem,
  IGradeSystems,
  IScoreWeight,
  IScoreWeights,
} from '../interfaces/grade-system';

@Injectable({
  providedIn: 'root',
})
export class GradeSystemsService {
  constructor(private httpClient: HttpClient) {}

  getGradeSystems(url: string): Observable<IGradeSystems> {
    return this.httpClient.get<IGradeSystems>(url, {
      headers: { accept: '*/*' },
    }) as Observable<IGradeSystems>;
  }

  getGradeSystem(url: string): Observable<IGradeSystem> {
    return this.httpClient.get<IGradeSystem>(url, {
      headers: { accept: '*/*' },
    }) as Observable<IGradeSystem>;
  }

  getScoreWeights(url: string): Observable<IScoreWeights> {
    return this.httpClient.get<IScoreWeights>(url, {
      headers: { accept: '*/*' },
    }) as Observable<IScoreWeights>;
  }

  create(url: string, form: any): Observable<any> {
    return this.httpClient.post<any>(url, form, {
      headers: { accept: '*/*' },
    }) as Observable<any>;
  }

  editGradeSystem(url: string, form: any): Observable<IGradeSystem> {
    return this.httpClient.patch<IGradeSystem>(url, form, {
      headers: { accept: '*/*' },
    }) as Observable<IGradeSystem>;
  }

  editScoreWeight(url: string, form: any): Observable<IScoreWeight> {
    return this.httpClient.patch<IScoreWeight>(url, form, {
      headers: { accept: '*/*' },
    }) as Observable<IScoreWeight>;
  }
}
